import './App.css';
import TableApp from './componentes/TableApp.jsx';

function App() {
  return (
    <div className="App">
        <TableApp />   
    </div>
  );
}

export default App;
